<template>
  <div id="services">
    <div v-if="error" class="response-handler">
      <Error />
    </div>
    <div v-if="loader" class="response-handler">
      <Loader />
    </div>
    <div :class="[i !== items.length - 1 ? 'card-border-bottom' : '', 'card-container']" v-for="(item, i) in items" :key="i">
      <service-and-feature-controller-card type="services" @refresh="fetchData(gsm)" :data="item"/>
    </div>
  </div>
</template>
<script>
import ServiceAndFeatureControllerCard from '../../../components/cards/ServiceAndFeatureControllerCard'
import ProfileServicesRepository from '../../../repositories/ProfileServicesRepository'
import Loader from '../../../components/LoaderBtn/Loader'
import Error from '../../../components/errorHandle/Error'
export default {
  components: { ServiceAndFeatureControllerCard, Loader, Error },
  data () {
    return {
      lang: this.$lang,
      serviceRepo: new ProfileServicesRepository(),
      items: [],
      gsm: this.$store.state.selectedNumber,
      error: false,
      loader: false
    }
  },
  created () {
    this.fetchData(this.gsm)
    this.$watch(() => {
      return this.$store.state.passedNum
    }, val => {
      this.items = []
      this.error = false
      this.loader = false
      this.fetchData(val)
    })
  },
  methods: {
    async fetchData (gsm) {
      const formData = new FormData()
      formData.append('gsm', gsm)
      this.loader = true
      try {
        const response = await this.serviceRepo.post(formData)
        if (response.data.status === 200) {
          if (gsm === this.$store.state.passedNum) {
            this.items = []
            for (let i = 0; i < response.data.data.length; i++) {
              this.items.push(response.data.data[i])
            }
          }
          this.error = false
          this.load = false
        } else {
          this.error = true
        }
        // console.log(response)
      } catch (e) {
        this.error = true
        console.log(e)
      }
      this.loader = false
    }
  }
}
</script>
<style lang="scss" scoped>
#services {
  padding: 0rem 1rem;
  height: calc(100vh - (90px + 110px));
  overflow-y: auto;
}
.response-handler{
  height: calc(100vh - (110px + 90px))
}
.card-container {
  padding: 1.5rem 0 .5rem 0;
}
.card-border-bottom{
  border-bottom: 2px solid rgba(0,0,0,.15);
}
@media (max-width: 1200px) {
  #services {
    overflow-y: unset;
  }
}
</style>
